module.exports = __webpack_public_path__ + "media/vid.ef99cf2e.mp4";